(function ($) {

	function init_remove_coupon_ajax() {
		$("[data-cart-remove-coupon]").off("click").on("click", function (e) {
			gp_ajax({
				url: ghostpress_params.ajax_url + "&action=cart_remove_coupon",
				type: "post",
				dataType: "json",
				data: {
					coupon_code: $(this).data("cart-remove-coupon"),
				},
				show_loading: true
			})
		})
	}

	$(document).gp_ready(init_remove_coupon_ajax)

})(jQuery);